import CheckboxComponent from "@/components/Checkbox";
import {
  JobsFilter,
  updateJobsFilter,
} from "@/lib/redux/jobsFilters/jobsFiltersSlice";
import { useAppDispatch } from "@/lib/redux/hooks";
import DropdownComponent from "./Dropdown";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Checkbox = CheckboxComponent as any;
const Dropdown = DropdownComponent as any;

type Props = {
  filter: JobsFilter;
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
};

const Selector: React.FC<Props> = (props) => {
  const { filter, isOpen, handleClose, handleOpen } = props;

  const dispatch = useAppDispatch();

  const isSelected = (value: string) => filter.selectedValues.includes(value);

  const handleChange = (value: string) => {
    const selectedValueSet = new Set(filter.selectedValues);
    if (isSelected(value)) {
      selectedValueSet.delete(value);
    } else {
      selectedValueSet.add(value);
    }
    dispatch(
      updateJobsFilter({
        id: filter.id,
        changes: {
          selectedValues: Array.from(selectedValueSet),
        },
      })
    );
  };

  const { locale = "it" } = useRouter();

  const t: Record<string, string | undefined> = {
    Country: useTranslation("jobsPage.filters.country", locale),
  };

  const getCountryNames = new Intl.DisplayNames([locale], {
    type: "region",
  });

  return (
    <Dropdown
      label={t[filter.id] || filter.id}
      isOpen={isOpen}
      handleOpen={handleOpen}
      handleClose={handleClose}
    >
      {filter.values.map((value) => (
        <Checkbox
          key={value}
          value={value}
          checked={isSelected(value)}
          onChange={() => handleChange(value)}
        >
          {getCountryNames.of(value)}
        </Checkbox>
      ))}
    </Dropdown>
  );
};

export default Selector;
